module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9516_beige.22bb74f1.jpg";